import { Component } from '@angular/core';

@Component({
  selector: 'ba-access-denied',
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent {

  constructor() { }

}
